const zh_CN :{[key: string]: string} = {
    login:'登录',
    email:'邮箱',
    cachierDesk:'收银台',
    password:'密码',
    userNameNotNull: 'E-Mail不能为空',
    passwrodNotNull: '密码不能为空',
    historyReport:'历史统计',
    setting:'设置',
    collectMoney:'我要收银',
    amtNotNull: '金额不能为空',
    amtShouldBeNum:'金额必须为数字',
    amtGreaterThan0:'金额必须大于0',
    amtShouldBeInteger: '金额不能有小数',
    amt: '金额',
    remark:'备注',
    genQr:'用户扫我',
    scanQr:'我扫用户',
    collectQr:'收款二维码',
    paySucc: '支付成功',
    unpaid: '未支付',
    modifyPass: '修改密码',
    passLengthError: '密码长度必须大于6位',
    passConfirmError: '两次密码不一致',
    oldPass:'旧密码',
    newPass: '新密码',
    confirmPass:'确认密码',
    confirmModify: '确认修改',
    transSucc: '交易成功',
    newOrder:'新订单',
    orderNo:'订单号',
    buyer: '付款方',
    payTime: '支付时间',
    finish: '完成',
    scanQrTips:'将二维码放入框内，即可自动扫描',
    lightOn: '开灯',
    lightOff: '关灯',
    logout:'退出登陆',
    confirmLogoutMsg:'您确认要退出当前账号么？',
    cancel: '取消',
    confirm:'确认',
    languages: '语言',
    refunded:'已退款',
    transFailed:'交易失败',
    refunding: '正在退款',
    refund: '退款',
    refundAmtLimit:'退款金额不能大于',
    canRefundAmt:'可退款金额',
    refundAll:'全额退款',
    refundAmt:'退款金额',
    report: '报表',
    dayReport:'日交易汇总',
    overview:'总览',
    transNum:'交易笔数',
    fee: '手续费',
    payment: '支付',
    orderDetail: '订单详情',
    status:'状态',
    transactions:'交易流水',
    noData:'暂无数据',
    noMore:'没有更多了',
    storeName:'门店名称',
    employeeName:'员工名称',
    employeeTitle:'员工职务',
    currency: '结算货币',
    basicInfo:'基本信息',
    keyError:'系统错误：密钥错误',
    modifySucc:'修改成功！',
    refundSucc: '退款成功！',
    SYSTEM_ERROR:'系统繁忙，请稍后再试',
    NETWORK_ERR: '网络错误',
    chooseLan:'选择语言',
    dealing:'正在处理',
    transFailTips: '交易失败, 请重新尝试',
    /////////2018.10.10///////////
    forgetPassword: '忘记密码?',
    contactUs: '联系我们',
    contactTips: '留下您的邮箱，方便我们与您联系。',
    submit: '提交',
    contactSuccTips:'提交成功, 我们将尽快与您联系。',
    expireTime:'失效时间:',
    home: '首页',
    bills: '对账单',
    my: '我的',
    partialRefunded: '部分退款',
    returnLogin: '返回登录',
    saveSucc: '保存成功!',
    todayIncome: '今日收入金额',
    todayTrans: '今日交易笔数',
    queryOrder:'订单查询',
    cameraNotAuthorzied: '相机未授权，请在设置中开启权限',
    camerarollDenied: '相册访问权限未授权，请在设置中开启',
    queryOrderTips: '请输入订单号或扫描订单条码',
    loading: '正在加载...',
    orderNoNotNull: '订单号不能为空',
    oldPasswrodNotNull: '旧密码不能为空',
    newPasswrodNotNull: '新密码不能为空',
    confirmPasswrodNotNull: '确认密码不能为空',
    emailNotNull: '邮箱不能为空',
    //=====2018.11.14====
    employeeManage: '员工管理',
    SUPER_ADMIN: '超级管理员',
    ADMIN: '门店管理员',
    CASHIER: '收银员',
    modifyUser: '修改员工信息',
    loginNo: '登陆账号',
    name: '员工姓名',
    phoneNumber: '手机号码',
    role: '角色',
    newUser: '新增员工',
    add: '新增',
    userBuyFee: '用户承担手续费',
    userBuyFee_checkout: '用户承担手续费',
    delete: '删除',
    pleaseInput: '请输入',
    pleaseSelect: '请选择',
    settlement: '结算中心',
    allDate: '全部日期',
    settlementAmt:'结算金额',
    merchantQr:'商户收款码',
    clickView: '点击查看',
    Alipay: '支付宝',
    Wechat: '微信',
    collectAmt: '支付金额',
    collectNum: '收款笔数',
    refundNum: '退款笔数',
    orderList:'订单列表',
    settlementDetail: '结算详情',
    current: '当前',
    scanBarcode: '扫描条码',
    photos: '相册',
    noQR: '未识别到二维码/条码',
    deleteSucc: '删除成功！',
    emailNoValid: 'E-mail格式不合法!',
    passwordLessThan6: '密码至少6位!',
    settled: '已结算',
    unSettled: '待结算',
    iSee: '我知道了',
    unSettledTips: '待结算金额还未扣除手续费，因手续费涉及小数的处理，需以实际结算为准',
    voiceTip: '收款语音播报',
    //======
    exchangeRate: '汇率',
    payCurrency: '交易货币',
    markupRate: '汇率上浮',
    modifyRate: '修改汇率上浮比率',
    confirmDeleteMsg:'确认删除该用户么？',
    company: '公司名称',
    contactPerson: '联系人',
    //=====
    storeNotNull: '必须选择所属店铺',
    allStore:'所有门店',
    turnOverLineTitle:'营业额日趋势（一周）',
    merchantStatsTitle: '店铺今日营业额',
    turnover: '营业额',
    storeManagement: '店铺管理',
    collapse: '收起',
    connected: '在线',
    disconnected: '断开',
    //====
    monthlyIncome: '本月收入金額',
    monthlyTradeNum: '本月交易笔数',
    collecting: '您正在收款',
    scanOrEnterPayQr: '请扫描或输入用户付款码',
    latestOrders: '最近订单',
    more: '查看更多',
    cancelled: '已取消',
    selectDate: '选择日期',
    startDate: '开始日期',
    endDate: '结束日期',
    settlementStatus: '结算状态',
    all: '全部',
    payType: '钱包',
    query: '查询',
    export: '导出',
    clear: '清空条件',
    unknown: '未知',
    pagiPrefix: '每页展示',
    pagiAfter: '条',
    settlementList: '结算历史',
    settlementDate: '结算日期',
    operations: '操作',
    downloadDetail: '下载明细',
    merchantInfo: '商户信息',
    country: '国家/地区',
    storeType: '门店类型',
    SINGLE: '单店',
    CHAIN_STORE: '连锁店',
    paymentSettings: '支付设置',
    modify: '更改',
    download: '下载',
    emialNotCorrect: '邮箱格式不正确',
    nameNotNull: '姓名不能为空',
    phoneNotCorrect: '手机号码不正确',
    lastLogin: '最后登陆时间',
    deleteUser: '删除用户',
    developerInfo: '开发者信息',
    merchantName: '商户名称',
    merchantNo: '商户号',
    view: '查看',
    storeInfo: '门店信息',
    storeId: '门店编号',
    interfaces: '可用接口',
    online: '線上',
    offline: '線下',
    webpage_api: '网站支付',
    app_api: 'APP支付',
    barcode_api: '付款码支付',
    transqr_api: '订单二维码支付',
    jsapi_api: 'JS API',
    dashboard: '收银台',
    orders: '订单管理',
    settlements: '结算管理',
    merchant: '商户管理',
    info: '基本信息',
    users: '员工信息',
    account:'账户信息',
    developer: '开发者',
    mustBeNumer:'必须为数字',
    modifyPassSucc: '修改成功，请用新密码重新登陆',
    addUserSucc: '添加员工成功！',
    newOrderNoitf: '您有新订单， 交易金额：',
    unpaidToast: '等待用户支付，请确认用户是否完成支付',
    queryOrderManually: '手动查询订单',
    manualQueryOrderTips: '说明: 输入或扫描订单号手动查询该笔订单的状态。当用户已支付，但管理台未收到消息时可以用该功能进行查询',
    findPassword: '找回密码',
    findPasswordTips: '请填写您的登陆账号，我们会给您发一封找回密码的邮件，根据邮件提示找回密码。',
    send: '发送',
    backToLogin:'返回登陆',
    resetPassword: '重置密码',
    resetPasswordTips: '您正在找回密码，请填写您的邮箱和新密码',
    sendSucc: '发送成功，请查看您的邮箱！',
    resetSucc: '重置成功，请用新密码进行登陆！',
    reSendText: '{second}秒后重发',
    msg404: '对不起，您要找的页面消失了！',
    //====
    balance: '账户余额',
    unsettled: '未结算金额',
    minimum: '最低提现金额',
    minimumSettlementAmount:'起结金额',
    settlementCurrency:'结算币种',
    acquirer:'收单机构',
    withdrawal: '可提现金额',
    cash: '提现',
    bank: '提现银行',
    accountNumber: '银行账号',
    accountName: '银行户名',
    money: '提现金额',
    cashToast: '提现金额必须大于等于最低提现金额，小于等于可提现金额',
    collection: '收款管理',
	collectionLink: '收款链接',
    createLink: '生成链接',
    storeChoose: '门店选择',
    searchLink: '查询链接',
    copy: '复制',
    copySuccess: '复制成功',
    copyError: '复制失败，请手动复制',
	transactionStatus: '交易状态',
	paid: '已支付',
	linkList: '链接列表',
    createTime: '创建时间',
    payNo: '支付订单号',
    partnerNo: '合作伙伴订单号',
    linkDetail: '链接详情',
	exchangeManage: '换汇管理',
	exchangeApply: '换汇申请',
	exchangeRecords: '换汇记录',
	canExchangeAmount: '可换汇金额',
	salesAmount: '换汇金额',
	buyingCurrency: '买入币种',
	defaultBank: '是否使用默认银行账号',
	yes: '是',
	no: '否',
	bankName: '银行名称',
	bankNumber: '银行账号',
	bankAccName: '银行户名',
	bankAddress: '银行地址',
	swiftcode: '银行Swiftcode',
	exchangeDetail: '换汇详情',
	currentCurrency: '卖出币种',
	purchaseAmount: '买入金额',
	availableBalance: '可用余额',
	improveBankInformation: '请完善银行信息！',
	sellToast: '请输入卖出金额!',
	currencyToast: '请选择币种！',
	successTime: '成功时间',
	exchangeSucc: '成功',
	untreated: '未处理',
	functionToast: '您尚未开通此功能！'
}

export default zh_CN